import React, { ReactElement} from 'react';

import { Assets } from '../../../../../utils/assets';
import { LITERATURE_LIST, SCIENCE_LIST } from '../../constants';
import { CardScroll } from '../cardScroll';
import * as S from './Resources.styles';

export const Resources = (): ReactElement => {
  return (
    <>
      <S.Divider />
      <S.Content>
        <S.Wrapper>
          <S.TextWrapper>
            <S.SubCaption>Brain.fm’s research and methods</S.SubCaption>
            <S.Caption>Read our science</S.Caption>
          </S.TextWrapper>
          <S.WaveImage alt={Assets.images.scienceResearchWave.alt} src={Assets.images.scienceResearchWave.url}/>
        </S.Wrapper>
        <CardScroll auraColor='red' list={SCIENCE_LIST}/>
        <S.Wrapper>
          <S.TextWrapper>
            <S.SubCaption>research about some of the methods we use</S.SubCaption>
            <S.Caption>Supporting literature</S.Caption>
          </S.TextWrapper>
          <S.WaveImage alt={Assets.images.scienceLiteratureWave.alt} src={Assets.images.scienceLiteratureWave.url}/>
        </S.Wrapper>
        <CardScroll auraColor='blue' list={LITERATURE_LIST}/>
      </S.Content>
      <S.Divider />
    </>
  );
};
